import { TUTORIAL_PRESETS } from './tutorial-presets.js';

const { match3, match4, special, mix } = TUTORIAL_PRESETS;

const GESTURE_SWIPE_RIGHT = 'swipe-right';
const ACTION_BOARD_MATCH = 'boardMatch';

export const STEP_DEFINITIONS = [
  {
    id: 'start',
    highlightSelector: '#button',
    allowedSelectors: ['#button'],
    allowedActions: ['start'],
    gesture: 'tap',
    message: ['まずはゲームを開始しましょう。', 'Startをタップしてください。'],
    transitionMessage: ['Great!'],
    advanceDelayMs: 600,
  },
  {
    id: 'match3',
    presetId: 'match3',
    focusCell: match3.focusCell,
    allowedCells: match3.allowedCells,
    completion: match3.completion,
    swapConstraints: match3.swapConstraints,
    allowedActions: [ACTION_BOARD_MATCH],
    gesture: GESTURE_SWIPE_RIGHT,
    setupMessage: ['基本操作を説明します。'],
    message: ['同じピースを3個そろえてください。', 'そろうとピースが消えます。'],
    transitionMessage: ['Great!'],
    advanceDelayMs: 900,
  },
  {
    id: 'match4',
    presetId: 'match4',
    focusCell: match4.focusCell,
    allowedCells: match4.allowedCells,
    completion: match4.completion,
    swapConstraints: match4.swapConstraints,
    allowedActions: [ACTION_BOARD_MATCH],
    gesture: GESTURE_SWIPE_RIGHT,
    setupMessage: ['次は4個以上そろえた時です。'],
    message: ['4個以上なら特殊ピースができます。', '狙って作成しましょう。'],
    transitionMessage: ['Great!'],
    advanceDelayMs: 900,
  },
  {
    id: 'special',
    presetId: 'special',
    focusCell: special.focusCell,
    allowedCells: special.allowedCells,
    completion: special.completion,
    swapConstraints: special.swapConstraints,
    allowedActions: [ACTION_BOARD_MATCH],
    gesture: GESTURE_SWIPE_RIGHT,
    setupMessage: ['次に特殊ピースを使ってみましょう。'],
    message: ['特殊ピースはスワイプで発動します。', '発動すると多くのピースを消せます。'],
    transitionMessage: ['Great!'],
    advanceDelayMs: 900,
  },
  {
    id: 'mix',
    presetId: 'mix',
    focusCell: mix.focusCell,
    allowedCells: mix.allowedCells,
    completion: mix.completion,
    swapConstraints: mix.swapConstraints,
    allowedActions: [ACTION_BOARD_MATCH],
    gesture: GESTURE_SWIPE_RIGHT,
    setupMessage: ['最後に特殊ピースの組み合わせです。'],
    message: ['特殊ピース同士をスワイプすると', '組み合わせ効果が発動します。'],
    advanceDelayMs: 700,
  },
];

export function getStepById(stepId) {
  return STEP_DEFINITIONS.find((definition) => definition.id === stepId) || null;
}

export function getStepAtIndex(index) {
  if (index < 0 || index >= STEP_DEFINITIONS.length) {
    return null;
  }
  return STEP_DEFINITIONS[index];
}
